module.exports = __webpack_public_path__ + "static/media/call-flow-sprite.52dddade.svg";